<div class="theme-page-container">
    <app-selectiontoolbar [strToolBarTitle]="'Select Exam'" [strSelectionTitle]="strSelectionTitle" [bShowSelectionButtons]="false"></app-selectiontoolbar>

    <div class="theme-page-body">
        <div *ngIf="bLoading" class="theme-spinner">
            <mat-spinner></mat-spinner>
        </div>
        <div class="theme-card-content">
            <div *ngFor="let examName of arrExamNames">
                <a (click)="setSelectedExam(examName)" routerLink="/marksentry" matRipple class="theme-card-item">
                    <div class="theme-card-item-content">
                        <div>{{ examName }} </div>
                    </div>
                    <div class="theme-card-item-link-icon">
                        <mat-icon class="material-icons-outlined">arrow_forward_ios</mat-icon>
                    </div>
                </a>
                <hr>
            </div>
        </div>
    </div>

</div>